import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorModal from '../ErrorModal/ErrorModal';
import { toast } from 'react-toastify';
import InputField from '../form/FormInput';

const PurchaseReceiveTableView = ({
	initialRows,
	columns,
	className,
	onChange,
	value,
	disabled,
	newRowgenerate = '',
	returnInputvalue,
	tableError,
	setIsTableErrorShow,
}) => {
	const [rows, setRows] = useState([]);
	const [totalProduct, setTotalProduct] = useState(0);
	const [totalQuantity, setTotalQuantity] = useState(0);
	const [errorCells, setErrorCells] = useState([]);
	const [showError, setShowError] = useState(false);
	const inputRefs = useRef([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (errorCells.length > 0) {
			setIsTableErrorShow(true);
		} else {
			setIsTableErrorShow(false);
		}
	}, [errorCells]);

	useEffect(() => {
		if (tableError && rows?.length > 0 && errorCells.length > 0) {
			const secondLastRowIndex = rows.length - 1;
			const secondLastRow = rows[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];
					return (
						(value === null || value === '') &&
						['product_id', 'order', 'receive', 'in-transit', 'qty'].includes(col.name)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));
			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter(
					(error) =>
						!(
							error.index === secondLastRowIndex &&
							(error.customErrorMessage === null || error.customErrorMessage === undefined)
						),
				),
				...errors,
			]);
		}
	}, [tableError]);

	function handleSetInitialTableData() {
		try {
			setLoading(true);

			const tableData = value?.length > 0 ? value : initialRows;

			setRows(tableData);

			let errors = [];

			tableData.forEach((row, index) => {
				errors = validateQtyRow(row, index, errors);
			});

			setErrorCells(errors);
		} catch (error) {
			toast.error('Something went wrong while loading product table!');
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		handleSetInitialTableData();
	}, [value]);

	// const addRow = () => {
	// 	const emptyRow = columns.reduce((acc, col) => {
	// 		acc[col.name] = '';
	// 		return acc;
	// 	}, {});
	// 	const newRows = [...rows, emptyRow];
	// 	setRows(newRows);
	// 	if (newRows.length > 1) {
	// 		const secondLastRowIndex = newRows.length - 2;
	// 		const secondLastRow = newRows[secondLastRowIndex];

	// 		const errors = columns
	// 			.filter((col) => {
	// 				const value = secondLastRow[col.name];
	// 				return (
	// 					(value === null || value === '') &&
	// 					['product_id', 'order', 'receive', 'in_transit', 'qty'].includes(col.name)
	// 				);
	// 			})
	// 			.map((col) => ({
	// 				index: secondLastRowIndex,
	// 				name: col.name,
	// 			}));
	// 		setErrorCells((prevErrorCells) => [
	// 			...prevErrorCells.filter((error) => !(error.index === secondLastRowIndex)),
	// 			...errors,
	// 		]);
	// 	}

	// 	if (onChange) {
	// 		onChange(newRows);
	// 	}
	// 	setTimeout(() => {
	// 		inputRefs.current[newRows.length - 1]?.[0]?.focus();
	// 		let lastRowRef = inputRefs.current[newRows.length - 1]?.[0];
	// 		lastRowRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
	// 	}, 0);
	// };

	const deleteRow = (index) => {
		if (rows.length > 1) {
			const newRows = [...rows];
			newRows.splice(index, 1);
			const newErrorCells = errorCells
				.filter((error) => error.index !== index)
				.map((error) => ({
					...error,
					index: error.index > index ? error.index - 1 : error.index,
				}));
			setErrorCells(newErrorCells);
			setRows(newRows);
			if (onChange) {
				onChange(newRows);
			}
			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
			}, 0);
		} else {
			setRows([]);
			setErrorCells([]);
			setRows(initialRows);
		}
	};

	const handleChange = (index, value, name) => {
		const newRows = [...rows];

		if (name === 'qty') {
			value = value.replace(/[^0-9]/g, '');
		}

		newRows[index][name] = value;

		let errors = errorCells;

		if (name === 'qty') {
			errors = validateQtyRow(newRows[index], index, errorCells);
		}

		setRows(newRows);
		setErrorCells(errors);

		onChange && onChange(newRows);
	};

	const validateQtyRow = (row, index, existingErrors = []) => {
		let errors = existingErrors.filter((err) => !(err.index === index && err.name === 'qty'));
		const qty = Number(row.qty || 0);
		const orderQty = Number(row.order_quantity || 0);
		const receivedQty = Number(row.received_quantity || 0);
		const remainingQty = orderQty - receivedQty;
		if (qty > 0 && orderQty > 0) {
			if (!row.qty || qty === 0) {
				errors.push({
					index,
					name: 'qty',
					customErrorMessage: {
						qty: 'Quantity cannot be empty or 0',
					},
				});
			} else if (qty > remainingQty) {
				errors.push({
					index,
					name: 'qty',
					customErrorMessage: {
						qty: `Quantity cannot exceed remaining (${remainingQty})`,
					},
				});
			}
		}

		return errors;
	};

	const handleRef = (rowIndex, cellIndex) => (el) => {
		if (!inputRefs.current[rowIndex]) {
			inputRefs.current[rowIndex] = [];
		}
		inputRefs.current[rowIndex][cellIndex] = el;
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'qty':
				return `Quantity can not be 0`;
			default:
				return '';
		}
	};

	useEffect(() => {
		if (rows.length > 0 && onChange) {
			onChange(rows);
		}
	}, [disabled]);

	const ErrorModalOpen = () => {
		setShowError(true);
	};
	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (rows.length > 0) {
				inputRefs.current[rows.length - 1]?.[0]?.focus();
			}
		}, 0);
	};

	const handleCount = useCallback(() => {
		const totalProductCount = rows.length;
		const totalQuantity = rows.reduce((acc, prod) => {
			acc = acc + Number(prod.qty);
			return acc;
		}, 0);

		setTotalProduct(totalProductCount);
		setTotalQuantity(totalQuantity);
	}, [rows]);

	useEffect(() => {
		handleCount();
	}, [rows]);

	return (
		<>
			{errorCells && errorCells?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center mb-2 custum_table">
				<div className=" custom-scroll">
					<table className="purchase-table">
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										className={`${className}`}
										key={col.name}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											{['qty'].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								<th>Actions</th>
							</tr>
						</thead>
						{loading ? (
							<div
								className="d-flex justify-content-center align-items-center"
								style={{
									marginTop: '5%',
									marginLeft: '40%',
									position: 'fixed ',
								}}
							>
								<span
									className="Page_loader"
									role="status"
									aria-hidden="true"
								></span>
							</div>
						) : (
							<tbody>
								{rows.map((row, rowIndex) => (
									<tr key={rowIndex}>
										{columns.map((col, cellIndex) => (
											<td
												key={col.name}
												style={{ textAlign: 'left' }}
												className={
													errorCells.some(
														(cell) => cell.index === rowIndex && cell.name === col.name,
													)
														? 'error'
														: ''
												}
											>
												{col.name === 'qty' ? (
													<InputField
														className="table_input"
														type={col.type}
														name={col.name}
														disabled={rows[0]['product_name'] === '' ? true : false}
														value={row[col.name]}
														style={{
															border: '1px solid rgba(85, 91, 103, 0.15)',
															borderRadius: '8px',
														}}
														onChange={(value) => {
															handleChange(rowIndex, value, col.name);
														}}
														ref={handleRef(rowIndex, cellIndex)}
													/>
												) : (
													row[col.name]
												)}
											</td>
										))}
										<td>
											<button
												className="delete mt-0 bg-transparent"
												onClick={() => deleteRow(rowIndex)}
												tabIndex="-1"
												disabled={disabled}
											>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M3 6H5H21"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M10 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M14 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											</button>
										</td>
									</tr>
								))}
							</tbody>
						)}
						<tfoot>
							<tr>
								<td style={{ textAlign: 'left' }}>Total Item : {totalProduct}</td>
								<td></td>
								<td></td>
								<td></td>
								<td style={{ textAlign: 'right' }}>Total : {totalQuantity}</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
				</div>
				{/* {!disabled && (
					<button
						className="bg-transparent text-dark add-new-row-button mt-2"
						onClick={addRow}
					>
						Add New Row
						<i
							className="fa fa-plus"
							style={{
								marginLeft: '.5rem',
								strokeWidth: '.1rem',
								color: 'var(--brand-color)',
								WebkitTextStrokeColor: '#fff',
								WebkitTextStrokeWidth: '1px',
							}}
						/>
					</button>
				)} */}
			</div>
			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Purchase Receive Table"
						error={errorCells}
					/>
				)}
			</div>
		</>
	);
};

export default PurchaseReceiveTableView;
